import { VacanciesTemplatesEditPage } from '@pages/vacanciesTemplates';

export default VacanciesTemplatesEditPage;
